export default {
    setSelectedQaProject(state, project) {
        state.selectedQaProject = project
        if (project === null) {
            state.qaData = null
        }
    },
    setQueryData(state, queryData) {
        state.searchQueryData = queryData
        console.log('Set query data mutation: ', state.searchQueryData)
    },
    setSelectedQaDevice(state, device) {
        state.selectedQaDevice = device
    },
    setQaData(state, data) {
        state.qaData = data
    },
    setPedestriansQaData(state,data){
      state.pedestriansQaData = data
    },
    setQaTableHeaderData(state, newData) {
        state.qaTableHeaderData = newData
        console.log('Table header data: ', state.qaTableHeaderData)
    },
    resetQaTableHeaderData(state) {
        state.qaTableHeaderData = {
            activeSorted: {
                field: '',
                order: ''
            },
            activeFilterField: '',
            filters: {avgSpeed: null, userClass: [], userType: null, eventAt: null, direction: null}
        }
    },
    setPedestriansQaTableHeaderData(state, newData) {
        state.pedestriansQaTableHeaderData = newData
        console.log('Table header data pedestrians: ', state.qaTableHeaderData)
    },
    resetPedestriansQaTableHeaderData(state) {
        state.pedestriansQaTableHeaderData = {
            activeSorted: {
                field: '',
                order: ''
            },
            activeFilterField: '',
            filters: {dwellList: null, userClass: [], userType: null, eventAt: null, direction: null}
        }
    },
    setQaValidationData(state, newData) {
        if (state.selectedQaDevice && state.selectedQaDevice._id === newData.dataDeviceId) {
            state.selectedQaDevice.qaValidation = newData
        }
    },
    setDataDeviceAvailableDatesAndCharts(state, data) {
        if (state.selectedQaDevice && state.selectedQaDevice._id === data.dataDeviceId) {
            if (data.responseData && data.responseData.availableDatesInTimeZone) {
                state.selectedQaDevice.availableDatesInTimeZone = data.responseData.availableDatesInTimeZone
                state.selectedQaDevice.chartsData = data.responseData.chartsData
            }
        }
    },
    setQaLegendSelection(state, selection) {
        state.qaLegendSelection = selection
    }
}
